// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/Login_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignOverview-module__backgroundContainer___Pt6Tg {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: calc(100vh - 100px); /* Take the full viewport height */
    display: flex;
    justify-content: center; /* Center the form horizontally */
    align-items: center; /* Center the form vertically */
    padding: 80px; /* Padding around the formContainer */
    box-sizing: border-box; /* Include padding in the total size */
    overflow: hidden; /* Prevent the background container from overflowing */
}

.CampaignOverview-module__formContainer___fiELe {
    background: white;
    color: black;
    width: 100%;
    max-height: calc(100vh - 160px - 50px); /* Ensure formContainer respects background padding vertically */
    padding: 80px;
    border-radius: 10px;
    box-sizing: border-box; /* Ensure padding is part of the container's size */
    overflow-y: auto; /* Enable internal scrolling if content exceeds available space */
/*    display: flex;
*/    flex-direction: column;
    justify-content: center; /* Center content vertically if formContainer is small */
}

.CampaignOverview-module__spacingBetweenElements___rmWQb{
    margin-top: 40px;
}

.CampaignOverview-module__deliveryButtonContainer___ZdeX0 {
    display: flex;
    justify-content: space-between;
    font-weight: 800;
}

.CampaignOverview-module__deliveryButton___gSkM0 {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    padding: 10px;
    border: 0px;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    height: 100%;
    box-shadow: 
        0 10px 20px rgba(0, 0, 0, 0.1), 
        0 6px 6px rgba(0, 0, 0, 0.1), 
        0 0 100px rgba(0, 0, 0, 0.1);
}

    .CampaignOverview-module__deliveryButton___gSkM0:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.CampaignOverview-module__deliveryButton_loading___IJxEG {
    opacity: 0.7;
    cursor: not-allowed;
}

.CampaignOverview-module__deliveryButton_text___RZIKl {
    line-height: 1;
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignOverview/CampaignOverview.module.css"],"names":[],"mappings":"AAAA;IACI,yDAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,2BAA2B,EAAE,kCAAkC;IAC/D,aAAa;IACb,uBAAuB,EAAE,iCAAiC;IAC1D,mBAAmB,EAAE,+BAA+B;IACpD,aAAa,EAAE,qCAAqC;IACpD,sBAAsB,EAAE,sCAAsC;IAC9D,gBAAgB,EAAE,sDAAsD;AAC5E;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,sCAAsC,EAAE,gEAAgE;IACxG,aAAa;IACb,mBAAmB;IACnB,sBAAsB,EAAE,mDAAmD;IAC3E,gBAAgB,EAAE,iEAAiE;AACvF;CACC,KAAK,sBAAsB;IACxB,uBAAuB,EAAE,wDAAwD;AACrF;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ;;;oCAGgC;AACpC;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".backgroundContainer {\n    background-image: url('../../../images/Login_background.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: calc(100vh - 100px); /* Take the full viewport height */\n    display: flex;\n    justify-content: center; /* Center the form horizontally */\n    align-items: center; /* Center the form vertically */\n    padding: 80px; /* Padding around the formContainer */\n    box-sizing: border-box; /* Include padding in the total size */\n    overflow: hidden; /* Prevent the background container from overflowing */\n}\n\n.formContainer {\n    background: white;\n    color: black;\n    width: 100%;\n    max-height: calc(100vh - 160px - 50px); /* Ensure formContainer respects background padding vertically */\n    padding: 80px;\n    border-radius: 10px;\n    box-sizing: border-box; /* Ensure padding is part of the container's size */\n    overflow-y: auto; /* Enable internal scrolling if content exceeds available space */\n/*    display: flex;\n*/    flex-direction: column;\n    justify-content: center; /* Center content vertically if formContainer is small */\n}\n\n.spacingBetweenElements{\n    margin-top: 40px;\n}\n\n.deliveryButtonContainer {\n    display: flex;\n    justify-content: space-between;\n    font-weight: 800;\n}\n\n.deliveryButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    padding: 10px;\n    border: 0px;\n    border-radius: 8px;\n    transition: background-color 0.3s ease;\n    height: 100%;\n    box-shadow: \n        0 10px 20px rgba(0, 0, 0, 0.1), \n        0 6px 6px rgba(0, 0, 0, 0.1), \n        0 0 100px rgba(0, 0, 0, 0.1);\n}\n\n    .deliveryButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.deliveryButton_loading {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.deliveryButton_text {\n    line-height: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundContainer": `CampaignOverview-module__backgroundContainer___Pt6Tg`,
	"formContainer": `CampaignOverview-module__formContainer___fiELe`,
	"spacingBetweenElements": `CampaignOverview-module__spacingBetweenElements___rmWQb`,
	"deliveryButtonContainer": `CampaignOverview-module__deliveryButtonContainer___ZdeX0`,
	"deliveryButton": `CampaignOverview-module__deliveryButton___gSkM0`,
	"deliveryButton_loading": `CampaignOverview-module__deliveryButton_loading___IJxEG`,
	"deliveryButton_text": `CampaignOverview-module__deliveryButton_text___RZIKl`
};
export default ___CSS_LOADER_EXPORT___;
